export const DEFAULT_TIMEZONE = 'Europe/Berlin';
export const TIMEZONE_KEY = 'companyTimezone';
